module.exports = __webpack_public_path__ + "static/media/galleryGT (19).1212e142.jpg";